/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllSourcesResponse } from './FindAllSourcesResponse';
import {
    FindAllSourcesResponseFromJSON,
    FindAllSourcesResponseFromJSONTyped,
    FindAllSourcesResponseToJSON,
} from './FindAllSourcesResponse';

/**
 * 
 * @export
 * @interface FindAllScreenerSources200Response
 */
export interface FindAllScreenerSources200Response {
    /**
     * 
     * @type {FindAllSourcesResponse}
     * @memberof FindAllScreenerSources200Response
     */
    data?: FindAllSourcesResponse;
}

/**
 * Check if a given object implements the FindAllScreenerSources200Response interface.
 */
export function instanceOfFindAllScreenerSources200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerSources200ResponseFromJSON(json: any): FindAllScreenerSources200Response {
    return FindAllScreenerSources200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerSources200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllSourcesResponseFromJSON(json['data']),
    };
}

export function FindAllScreenerSources200ResponseToJSON(value?: FindAllScreenerSources200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllSourcesResponseToJSON(value.data),
    };
}

